const Progress = ({ active }) => {
    return (
        <div>
            <ol className="flex w-full items-center justify-between mb-10">
                <li className="relative sm:p-2">
                    <span className={`centerOfParent bg-primary lg:w-11 lg:h-11 sm:w-10 sm:h-10 w-6 h-6 sm:text-base text-xs sm:font-light font-bold text-white rounded-full`}>
                        ۱
                    </span>
                </li>
                <li className={`flex-[1_0_0] h-px border ${active > 1 ? 'border-primary' : ''}`}></li>
                <li className="relative sm:p-2">
                    <span className={`centerOfParent ${active > 1 ? 'bg-primary' : 'bg-[#ffabc5]'} lg:w-11 lg:h-11 sm:w-10 sm:h-10 w-6 h-6 sm:text-base text-xs sm:font-light font-bold text-${active > 1 ? 'white' : 'gray-500'} rounded-full`}>
                        ۲
                    </span>
                </li>
                <li className={`flex-[1_0_0] h-px border ${active > 2 ? 'border-primary' : ''}`}></li>
                <li className="relative sm:p-2">
                    <span className={`centerOfParent ${active > 2 ? 'bg-primary' : 'bg-[#ffabc5]'} lg:w-11 lg:h-11 sm:w-10 sm:h-10 w-6 h-6 sm:text-base text-xs sm:font-light font-bold text-${active > 2 ? 'white' : 'gray-500'} rounded-full`}>
                        ۳
                    </span>
                </li>
                <li className={`flex-[1_0_0] h-px border ${active > 3 ? 'border-primary' : ''}`}></li>
                <li className="relative sm:p-2">
                    <span className={`centerOfParent ${active > 3 ? 'bg-primary' : 'bg-[#ffabc5]'} lg:w-11 lg:h-11 sm:w-10 sm:h-10 w-6 h-6 sm:text-base text-xs sm:font-light font-bold text-${active > 3 ? 'white' : 'gray-500'} rounded-full`}>
                        ۴
                    </span>
                </li>
                <li className={`flex-[1_0_0] h-px border ${active > 4 ? 'border-primary' : ''}`}></li>
                <li className="relative sm:p-2">
                    <span className={`centerOfParent ${active > 4 ? 'bg-primary' : 'bg-[#ffabc5]'} lg:w-11 lg:h-11 sm:w-10 sm:h-10 w-6 h-6 sm:text-base text-xs sm:font-light font-bold text-${active > 4 ? 'white' : 'gray-500'} rounded-full`}>
                        ۵
                    </span>
                </li>
                <li className={`flex-[1_0_0] h-px border ${active > 5 ? 'border-primary' : ''}`}></li>
                <li className="relative sm:p-2">
                    <span className={`centerOfParent ${active > 5 ? 'bg-primary' : 'bg-[#ffabc5]'} lg:w-11 lg:h-11 sm:w-10 sm:h-10 w-6 h-6 sm:text-base text-xs sm:font-light font-bold text-${active > 5 ? 'white' : 'gray-500'} rounded-full`}>
                        ۶
                    </span>
                </li>
            </ol>
        </div>
    );
};

export default Progress;